import React from "react";

import {
  INotificationRecipient,
  INotificationRecipientType
} from "src/core/notifications/api/notifications.api";
import { Text } from "src/library/components/Text";
import { ITerminology } from "src/library/utils";

interface AudienceCellProps {
  recipients: INotificationRecipient[] | undefined,
  terminology: ITerminology
}
/**
 * Displays the notification entity type and a list of entities underneath
 * for use in notification tables
 */
export const AudienceCell: React.ReactFCWithChildren<AudienceCellProps> = props => {
  if (props.recipients?.length) {
    const recipientType: INotificationRecipientType = props.recipients ? props.recipients[ 0 ].type : "global";
    let displayType = "";

    switch (recipientType) {
      case "branch":
        displayType = props.terminology.drop.plural.text;
        break;
      case "customer":
        displayType = props.terminology.customer.plural.text;
        break;
      case "global":
        displayType = "Global";
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Text as="h4">
          {displayType}
        </Text>

        {props.recipients?.map(nr => {
          if (nr.entity) {
            switch (nr.type) {
              case "branch":
                if ("branchNumber" in nr.entity) {
                  return (
                    <Text>
                      {`${nr.entity.branchNumber} ${nr.entity.name}`}
                    </Text>
                  );
                }
                break;
              case "customer":
                if ("accountNumber" in nr.entity) {
                  return (
                    <Text>
                      {`${nr.entity.accountNumber} - ${nr.entity.name}`}
                    </Text>
                  );
                }
                break;
              case "global":
                return (
                  <Text as="h4">
                    Global
                  </Text>
                );
              default:
                return null;
            }
          }

          return null;
        })}

      </div>
    );
  } else {
    return null;
  }
};
